"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AntDLayout = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const render_layout_elements_1 = require("./render-layout-elements");
function AntDLayoutComponent({ elements, schema, path, enabled, renderers, cells, direction = "column", }) {
    if (!elements?.length && !Object.keys(elements).length) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, render_layout_elements_1.renderLayoutElements)(elements, schema, path, !!enabled, renderers, cells, direction) }));
}
exports.AntDLayout = react_1.default.memo(AntDLayoutComponent);
